import { toast } from "react-toastify"
import mainAxios from "../../../services/mainAxios"
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppContext } from "../../../AppContext";
import { removePropertiesRecursive } from "../../../services/functions";



export const useGetPaymentOrderById= (id)=>{
  const [loading,setLoading] = useState(true)
  const [data,setData] = useState()

  const getPaymentOrder =async (paymentOrderId)=>{
    return mainAxios.post("/payment-orders/search",{
        object:"GetPaymentOrderById",
      params: { id:paymentOrderId ?? id }
    }).then(res=>{
      setLoading(false)
      if(res.data.status){
        setData(res.data.content[0])
        return res.data.content[0]
      }
      return null
    })
    .catch(err=>{
      setLoading(false)
      return null
    })
  }

  useEffect(()=>{
    if(id){
      getPaymentOrder()
    }
  },[id])

 return {getPaymentOrder,loading,setLoading,data,setData}

}

export const checkForAccountErrors = (errors,type="seller") => {
    return Object.keys(errors || {}).some(
      key => key.startsWith(type=="seller"?'sellerBankAccountTransactional.':"buyerBankAccountTransactional.")
    );
  };

export const useSavePaymentOrder= ({valid,setEditBankAccountModal}={})=>{
  const [loading,setLoading] = useState(false)
  const history = useHistory()
  const { t } = useTranslation("translations");
  const {selectedCompany:[selectedCompany],company:[company]}= useAppContext()

  const savePaymentOrderFn = ({paymentOrder,actionStatus={},onSuccess,onError,showSuccessToast=true}={})=>{
    const { action="SAVE"  } = actionStatus
    setLoading(true)
    const validObj =valid && valid()
    if(valid && !validObj?.isValid){
      toast.error(t("common.fixValidations"),{ containerId: "all_toast" })
      setLoading(false);
      return
    }
    const parsedBody={
      operation:action.toUpperCase(),
      content:{
        ...paymentOrder,
        companyId:selectedCompany,
      },
      nuis: company.nuis,
    }
    mainAxios
      .post("/payment-orders/save", parsedBody, { showSuccessToast })
      .then((res) => {
        setLoading(false);
        if(res.data.status){
          if(onSuccess){
            onSuccess(res.data.content[0])
          }else{
            history.push("/edit-payment-order/" + res.data.content[0].id);
          }
        }
        if(onError) onError(res)

      })
      .catch((err) => {
        if(onError) onError(err)
        setLoading(false);
      });
  }
  return {savePaymentOrderFn,loading,setLoading}
}

export const useDuplicatePaymentOrder = ({ currentPaymentOrder, id, onSuccess } = {}) => {
  const { getPaymentOrder } = useGetPaymentOrderById();
  const { t } = useTranslation("translations");
  const [duplicateLoading, setDuplicateLoading] = useState(false);

  const history = useHistory()
  const { savePaymentOrderFn } = useSavePaymentOrder({
    valid: () => ({isValid:true})
  });

  const duplicatePaymentOrder =async (currentId) => {
    setDuplicateLoading(true);

    let paymentOrderToUse = currentPaymentOrder

    if(!currentPaymentOrder){
      paymentOrderToUse = await getPaymentOrder(currentId ?? id)
    }



    if (!paymentOrderToUse) {
      console.error("No payment order data available");
      toast.error(t("paymentOrder.noDataAvailable") || "No payment order data available", {
        containerId: "all_toast"
      });
      setDuplicateLoading(false);
      return;
    }

    const {
      recordDate,
      recordUser,
      modificationDate,
      modificationUser,
      requestId,
      createdDateTime,
      transactionId,
      transactionDate,
      approvalUser,
      approvalDate,
      sentToBankDate,
      parentPaymentOrderId,
      paymentOrderHistorics,
      conditions,
      bankStatus,
      endToEndId,
      referenceNo,
      comment,
      ...restPaymentOrder
    } = paymentOrderToUse;

    const pathsToPreserveId = ['workflowStatus'];
    const cleanedPaymentOrder = removePropertiesRecursive(restPaymentOrder, pathsToPreserveId);

    cleanedPaymentOrder.workflowStatus = {
      id: 1,
      name: "DRAFT"
    };

    if (cleanedPaymentOrder.description) {
      cleanedPaymentOrder.description = cleanedPaymentOrder.description.trim();
    }
    if (cleanedPaymentOrder.companyAccountNumber) {
      cleanedPaymentOrder.companyAccountNumber = cleanedPaymentOrder.companyAccountNumber.trim();
    }



    savePaymentOrderFn({
      paymentOrder: cleanedPaymentOrder,
      actionStatus: { action: "SAVE" },
      onSuccess: (savedPaymentOrder) => {
        setDuplicateLoading(false);
        toast.success(t("paymentOrder.paymentOrderDuplicated"), {
          containerId: "all_toast"
        });
        history.push("/edit-payment-order/" + savedPaymentOrder.id);

        if (onSuccess) {
          onSuccess(savedPaymentOrder);
        }
      },
      showSuccessToast: false
    });
    setDuplicateLoading(false);

  };

  return {
    duplicatePaymentOrder,
    loading:  duplicateLoading
  };
};


